/* global swal */
import './style.less';

export default function($log, $q, $state, $stateParams, ProfileClass, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.tabs = {
    user: true,
    admin: false,
    author: false,
    finished: false
  };

  const { profile_uid: profile_profile_uid, company_id } = ProfileClass.profileComplete.profile;
  const profile_uid = $stateParams.employeeID || $stateParams.id || profile_profile_uid;
  vm.open = index => Object.keys(vm.tabs).forEach((key, i) => (vm.tabs[key] = index === i));

  // User Getting Started Functions
  function userGettingStarted({ tasks, completed, total }) {
    const params = {
      tab: 'user',
      title: 'Become a learning professional',
      completed,
      total,
      tasks: []
    };

    if (tasks.profile !== undefined) {
      params.tasks.push({
        primaryText: 'Fill out user profile',
        link: '^.profile',
        params: { tour: 'start' },
        completed: tasks.profile
      });
    }

    if (tasks.license !== undefined) {
      params.tasks.push({
        primaryText: 'Add your first license',
        link: '^.license',
        params: { tour: 'start' },
        completed: tasks.license
      });
    }
    if (tasks.certs !== undefined) {
      params.tasks.push({
        primaryText: 'Add Hours',
        link: '^.certificates.hours',
        params: { tour: 'start' },
        completed: tasks.certs
      });
    }

    return params;
  }

  // User Getting Started ^

  // Admin Getting Started Functions
  function adminGettingStarted({ tasks, completed, total }) {
    function createSponsor(task) {
      task.loading = true;
      ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'sponsors' }, {})
        .then(({ data: { item: { sponsor_id } } }) => {
          task.loading = false;
          $state.go('app.admin.sponsors.sponsor', { id: $stateParams.id, sponsor_id, tour: 'start' });
        })
        .catch(error => {
          task.loading = false;
          $log.error(error);
          throw error;
        });
    }

    const params = {
      tab: 'admin',
      title: 'Become a learning administrator',
      completed,
      total,
      tasks: []
    };

    if (tasks.sponsor !== undefined) {
      params.tasks.push({
        primaryText: 'Create a sponsor.',
        action: createSponsor,
        completed: tasks.sponsor,
        loading: false
      });
    }
    if (tasks.departments !== undefined) {
      params.tasks.push({
        primaryText: 'Create your first department.',
        link: 'app.admin.settings.departments',
        params: { id: $stateParams.id, tour: 'start' },
        completed: tasks.departments
      });
    }
    if (tasks.levels !== undefined) {
      params.tasks.push({
        primaryText: 'Create your first level',
        link: 'app.admin.settings.levels',
        params: { id: $stateParams.id, tour: 'start' },
        completed: tasks.levels
      });
    }
    if (tasks.locations !== undefined) {
      params.tasks.push({
        primaryText: 'Create your first location.',
        link: 'app.admin.settings.locations',
        params: { id: $stateParams.id, tour: 'start' },
        completed: tasks.locations
      });
    }
    if (tasks.practiceAreas !== undefined) {
      params.tasks.push({
        primaryText: 'Create your first practice area.',
        link: 'app.admin.settings.practiceAreas',
        params: { id: $stateParams.id, tour: 'start' },
        completed: tasks.practiceAreas
      });
    }

    return params;
  }

  // Admin Getting Started ^

  // Author Getting Started Functions
  function authorGettingStarted({ tasks, completed, total }) {
    function createEvaluationForm(task) {
      task.loading = true;
      ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'evaluationForms' }, {})
        .then(({ data: { item: { form_id } } }) => {
          task.loading = false;
          $state.go('app.author.evaluationForms.evaluationForm.edit', {
            id: $stateParams.id,
            form_id,
            tour: 'start'
          });
        })
        .catch(error => {
          task.loading = false;
          $log.error(error);
          throw error;
        });
    }

    const params = {
      tab: 'author',
      title: 'Become a learning author',
      completed,
      total,
      tasks: []
    };

    if (tasks.evaluations !== undefined) {
      params.tasks.push({
        primaryText: 'Create a evaluation form',
        action: createEvaluationForm,
        completed: tasks.evaluations,
        loading: false
      });
    }

    if (tasks.activities !== undefined) {
      params.tasks.push({
        primaryText: 'Create your first activity',
        link: 'app.author.activities.activity',
        params: { id: $stateParams.id, activity_id: null, tour: 'start' },
        completed: tasks.activities
      });
    }

    return params;
  }

  // Author Getting Started ^

  function completedGettingStarted(finished) {
    function complete(task) {
      task.loading = true;
      const params = {
        profile_uid: $stateParams.id,
        gettingStarted: false
      };
      ApiClass.usersIdPatch({ id: profile_uid }, params)
        .then(() => {
          task.loading = false;
          $state.go('app.users.dashboard', $stateParams);
        })
        .catch(error => {
          task.loading = false;
          $log.error(error);
          throw error;
        });
    }

    const params = {
      tab: 'finished',
      title: 'Completed Getting Started',
      completed: 0,
      total: 1,
      tasks: [
        {
          primaryText: 'You have completed the getting started guide click here to dismiss.',
          btnText: 'Complete',
          action: complete,
          completed: !!finished,
          loading: false
        }
      ]
    };

    return params;
  }

  function activate() {
    $log.debug('Getting started controller activated');
    vm.steps = [];
    ApiClass.usersIdGet(
      { id: profile_uid },
      {},
      {
        queryParams: {
          'include:gettingStarted': true
        }
      }
    )
      .then(({ data: { item, gettingStarted } }) => {
        const { admin, author, user, completed, total, finished } = gettingStarted;

        if (user.total) vm.steps.push(userGettingStarted(user));
        if (admin.total) vm.steps.push(adminGettingStarted(admin));
        if (author.total) vm.steps.push(authorGettingStarted(author));
        if (completed === total) {
          vm.steps.push(completedGettingStarted(finished));
          return vm.open(3);
        }

        if (user.completed === user.total && admin.completed === admin.total) return vm.open(2);
        if (user.completed === user.total) vm.open(1);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/gettingStarted/index.js